import { Interjection } from '../../types'

const ёпт: Interjection = {
  type: 'interjection',
  interjection: 'ёпт',
}

export default ёпт
